import {
  hasAdminAccess,
  hasHubspotTicketAccess,
  type UserRole,
} from '../../utils/roleUtils';

export interface SidebarUtilityNavItem {
  id:
    | 'alerts'
    | 'dapps'
    | 'publishers'
    | 'reporting'
    | 'tickets'
    | 'aiSummaries';
  to: string;
  label: string;
}

const BASE_UTILITY_NAV_ITEMS: SidebarUtilityNavItem[] = [
  {
    id: 'alerts',
    to: '/dashboard/alerts',
    label: 'Alerts',
  },
];

const ADMIN_UTILITY_NAV_ITEMS: SidebarUtilityNavItem[] = [
  {
    id: 'reporting',
    to: '/reporting',
    label: 'Reporting',
  },
  {
    id: 'tickets',
    to: '/tickets',
    label: 'Tickets',
  },
  {
    id: 'aiSummaries',
    to: '/ai-summaries',
    label: 'AI Summaries',
  },
];

export function getSidebarUtilityNavItems(
  role: UserRole | null | undefined,
  email?: string | null,
): SidebarUtilityNavItem[] {
  if (role && hasAdminAccess(role, email)) {
    const items: SidebarUtilityNavItem[] = [
      ...BASE_UTILITY_NAV_ITEMS,
      { id: 'dapps', to: '/dapps', label: 'Dapps' },
      { id: 'publishers', to: '/publishers', label: 'Publishers' },
      ...ADMIN_UTILITY_NAV_ITEMS,
    ];

    return items;
  }

  if (role && hasHubspotTicketAccess(role, email)) {
    const items: SidebarUtilityNavItem[] = [
      ...BASE_UTILITY_NAV_ITEMS,
      { id: 'dapps', to: '/dapps', label: 'Dapps' },
      { id: 'publishers', to: '/publishers', label: 'Publishers' },
      { id: 'tickets', to: '/tickets', label: 'Tickets' },
    ];
    return items;
  }

  return BASE_UTILITY_NAV_ITEMS;
}
